module.exports = __webpack_public_path__ + "static/media/may_2025_1.17f50e7c.webp";